import React from 'react';
import TopUtilityHeader from '../TopUtilityHeader';
import NewHeader from '../NewHeader';
import Footer from '../Footer';

const MainLayout = ({ children }) => {
  return (
    <div className="flex flex-col min-h-screen">
      <TopUtilityHeader />
      <NewHeader />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;
